<div *ngIf="isVisible">

  <div class="loading" *ngIf="showloader">
    <div class="loading_txt">
      <div class="load_txt">{{"returnsUK.loadinglabel" | cxTranslate}}</div>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>



  <div class="col-xs-12 UkCreateReturn" id="newReturnProduct">
    <div *ngIf="addtnlreturnSection">
      <section class="col-md-12 no-padding newReturnText">
        <div class="col-md-6 newReturns_subheader">
          {{"returnsUK.additionalreturn" | cxTranslate}}
        </div>
      </section>
      <div class="productbox" *ngIf="additionalReturnData">


        <!-- we can repeat from here -->



        <div class="specificlocation" id="AdditioanlReturnProduct">
          <div>
            <div class="newReturn_productheader">{{"returnsUK.prodtoreturn" | cxTranslate}}</div>


            <div class="newReturn_location">{{ additionalReturnData.returnsOrderData.companyName }}</div>

            <div class="row productrow">
              <div class="col-xs-3 no-padding locationdetail">
                <div class="col-xs-12 no-padding newReturn_locationdetails">
                  {{ additionalReturnData.returnsOrderData.addressLine1 }},
                  {{ additionalReturnData.returnsOrderData.town }}<br>
                  {{ additionalReturnData.returnsOrderData.postalCode }}</div>
              </div>
              <!--AQIV PRODUCT COLUMN-->
              <div *ngIf="hasProduct('aQIV') || hasProduct('aTIV')"
                class="col-xs-5 no-padding Returnaqivbox addtnlMaxCheck">
                <div class="productname">{{"returnsUK.ativlabel" | cxTranslate}}</div>
                <div class="year">{{"returnsUK.65yeartxt" | cxTranslate}}</div>
                <div class="enterdosestext">{{"returnsUK.enterdosestxt" | cxTranslate}}</div>
                <!--Total doses remain-->
                <table class="Returntotalbox">
                  <tbody>
                    <tr class="totalrow">
                      <td class="total_Txt">{{"returnsUK.totalaqiv" | cxTranslate}}</td>

                      <td class="prevtotal">{{ calculateTotalSelectedDoses(hasProduct('aQIV') ? 'aQIV' : 'aTIV') }}</td>

                      <td class="returnparent has-feedback has-success"><input type="text"
                          class="addtotal form-control blanktotalvalue"
                          [value]="calculateTotalAdditionalDoses(hasProduct('aQIV') ? 'aQIV' : 'aTIV') || ''" readonly
                          aria-invalid="false"></td>
                      <td class="completetotal">{{ calculateTotalDoses(hasProduct('aQIV') ? 'aQIV' : 'aTIV') || '' }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4"></td>
                    </tr>
                  </tbody>
                </table>
                <!--Product batch details-->
                <table class="prodcutbatch aqivreturn">
                  <tbody>
                    <tr class="borderB10">
                      <th>{{"returnsUK.batchnolabel" | cxTranslate}}</th>
                      <th>{{"returnsUK.dosesprevreturned" | cxTranslate}}</th>
                      <th [ngClass]=" aqivmaxquantity <= 0 ?'disableaddiotnalhead':''">{{"returnsUK.additionaldosereturn" | cxTranslate}}</th>
                      <th>{{"returnsUK.totaldosesreturned" | cxTranslate}}</th>
                    </tr>
                    <ng-container
                      *ngFor="let product of additionalReturnData.returnsOrderData.locations[0].returnsProduct;">
                      <tr *ngIf="product.productName === 'aQIV' || product.productName === 'aTIV'">
                        <td>{{ product.batchNumber }}</td>
                        <td class="previous">{{ product.selectedQuantity.toString() }}</td>
                        <td class="aqivReturninput returnparent has-feedback has-success">
                          <ng-container *ngIf="aqivmaxquantity>0">

                            <input type="text" autocomplete="no" class="addbatch form-control returninput"
                            [ngClass]="product.aqivbatcherror?'redhighlight_add':''"
                              [(ngModel)]="product.additionalQuantity" [disabled]="ismaxAqivQuantityZero()"
                              (keypress)="restrictInput($event)" (ngModelChange)="updateTotals(product)"
                              aria-invalid="false">

                          </ng-container>
                          <ng-container *ngIf="aqivmaxquantity <= 0">
                            <div class="sorblcoktext">You have already claimed your full SOR for this product</div>
                          </ng-container>
                        </td>

                        <td class="bacthtotal">{{ calculateTotalDosesReturned(product).toString() || '' }}</td>
                      </tr>
                    </ng-container>
                    <!--  loop end's here-->
                    <tr class="rowgap">
                    </tr>
                  </tbody>
                </table>
                <!--total credit doses details-->
                <table class="add_Return_Credit_Doses">
                  <tbody>
                    <tr class="total_Credit_Doses">
                      <td class="total_Txt">{{"returnsUK.totalativcredittxt" | cxTranslate}}</td>
                      <td class="prevtotal">{{ calculateTotalcreditprev(hasProduct('aQIV') ? 'aQIV' : 'aTIV') }}</td>
                      <td class="returnparent"><input type="text" class="addtotal form-control blanktotalvalue"
                          [value]="getTotalDosesForCredit(hasProduct('aQIV') ? 'aQIV' : 'aTIV') || ''" readonly=""
                          aria-invalid="false">
                      </td>
                      <td class="completetotal">{{ getCreditTotal(hasProduct('aQIV') ? 'aQIV' : 'aTIV') }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="clearboth"></div>
              </div>
              <!--QIVC PRODUCT COLUMN-->
              <div class="col-xs-5 no-padding Returnqivcbox addtnlMaxCheck"
                *ngIf="hasProduct('QIVc') || hasProduct('TIVc')">
                <div class="productname">{{"returnsUK.tivclabel" | cxTranslate}}</div>
                <div class="year">{{"returnsUK.6monthtxt" | cxTranslate}}</div>
                <div class="enterdosestext">{{"returnsUK.enterdosestxt" | cxTranslate}}</div>
                <!--Total doses remain-->
                <table class="Returntotalbox">
                  <tbody>
                    <tr class="totalrow">
                      <td>{{"returnsUK.totalqivc" | cxTranslate}}</td>
                      <td class="prevtotal"> {{ calculateTotalSelectedDoses(hasProduct('QIVc') ? 'QIVc' : 'TIVc') }}
                      </td>
                      <td class="returnparent has-feedback has-success"><input type="text"
                          class="addtotal form-control blanktotalvalue"
                          [value]="calculateTotalAdditionalDoses(hasProduct('QIVc') ? 'QIVc' : 'TIVc') || ''" readonly
                          aria-invalid="false">
                      </td>
                      <td class="completetotal">{{ calculateTotalDoses(hasProduct('QIVc') ? 'QIVc' : 'TIVc') || '' }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4"></td>
                    </tr>
                  </tbody>
                </table>
                <!--Product batch details-->
                <table class="prodcutbatch qivcreturn">
                  <tbody>
                    <tr class="borderB10">
                      <th>{{"returnsUK.batchnolabel" | cxTranslate}}</th>
                      <th>{{"returnsUK.dosesprevreturned" | cxTranslate}}</th>
                      <th [ngClass]=" qivcmaxquantity <= 0 ?'disableaddiotnalhead':''">{{"returnsUK.additionaldosereturn" | cxTranslate}}</th>
                      <th>{{"returnsUK.totaldosesreturned" | cxTranslate}}</th>
                    </tr>
                    <ng-container
                      *ngFor="let product of additionalReturnData.returnsOrderData.locations[0].returnsProduct;">
                      <tr *ngIf="product.productName === 'QIVc' || product.productName === 'TIVc'">
                        <td>{{ product.batchNumber }}</td>
                        <td class="previous">{{ product.selectedQuantity.toString() }}</td>

                        <td class="QIVcReturninputs returnparent has-feedback has-success " >
                          <ng-container *ngIf="qivcmaxquantity>0">

                            <input type="text" autocomplete="no" class="addbatch form-control returninput"
                              [disabled]="isQivcQuantityZero()"
                              [ngClass]="product.qivcbatcherror?'redhighlight_add':''"
                              [(ngModel)]="product.additionalQuantity" (ngModelChange)="updateTotals(product)"
                              (keypress)="restrictInput($event)" aria-invalid="false">



                          </ng-container>

                          <ng-container *ngIf=" qivcmaxquantity <= 0 ">
                            <div class="sorblcoktext">You have already claimed your full SOR for this product</div>
                          </ng-container>
                        </td>
                        <td class="bacthtotal">{{ calculateTotalDosesReturned(product).toString() || '' }}</td>
                      </tr>
                    </ng-container>
                    <!-- end's here-->
                    <tr class="rowgap"></tr>
                  </tbody>
                </table>
                <!--total credit doses details-->
                <table class="add_Return_Credit_Doses">
                  <tbody>
                    <tr class="total_Credit_Doses">
                      <td class="total_Txt">{{"returnsUK.totaltivccredittxt" | cxTranslate}}</td>
                      <td class="prevtotal">{{ calculateTotalcreditprev(hasProduct('QIVc') ? 'QIVc' : 'TIVc') }}</td>
                      <td class="returnparent"><input type="text" class="addtotal form-control blanktotalvalue"
                          [value]="getTotalDosesForCredit(hasProduct('QIVc') ? 'QIVc' : 'TIVc') || ''" readonly=""
                          aria-invalid="false">
                      </td>
                      <td class="completetotal">{{ getCreditTotal(hasProduct('QIVc') ? 'QIVc' : 'TIVc') || '' }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="clearboth"></div>
              </div>
            </div>
            <div class="row productrow">
              <div class="col-xs-3 no-padding"></div>
              <div class="sor_Terms_Txt">Based on your agreed sale or return percentage.</div>
              <div class="col-xs-5 no-padding Returnaqivbox addtnlMaxCheck" *ngIf="hasProduct('aQIV') || hasProduct('aTIV')">
                <ng-container
                  *ngIf="additionalReturnData.returnsOrderData.locations[0].aqiverrorsor;else checkquantity"> <span
                    class="batcherror"><i class="fa-solid fa-circle-exclamation"></i>&nbsp;{{"returnsUK.maxdoseerror" |
                    cxTranslate}}</span></ng-container>
                <ng-template #checkquantity> <span class="batcherror" *ngIf="aqivErrorMessage"><i
                      class="fa-solid fa-circle-exclamation"></i>&nbsp;{{ aqivErrorMessage }}</span></ng-template>
              </div>
              <div class="col-xs-5 no-padding Returnqivcbox addtnlMaxCheck" *ngIf="hasProduct('QIVc') || hasProduct('TIVc')">
                <ng-container
                  *ngIf="additionalReturnData.returnsOrderData.locations[0].qivcerrorsor;else checkquantityqivc"> <span
                    class="batcherror"><i class="fa-solid fa-circle-exclamation"></i>&nbsp;{{"returnsUK.maxdoseerror" |
                    cxTranslate}}</span></ng-container>
                <ng-template #checkquantityqivc> <span class="batcherror" *ngIf="qivcErrorMessage"><i
                      class="fa-solid fa-circle-exclamation"></i>&nbsp;{{ qivcErrorMessage }}</span></ng-template>


              </div>
            </div>

            <div class="row productrow">
              <div class="col-xs-3 no-padding"></div>
              <div class="col-xs-5 no-padding Returnaqivbox addtnlMaxCheck">
                <span class="batcherror" *ngIf="productErrorMessage">
                  <i class="fa-solid fa-circle-exclamation"></i>&nbsp;{{ productErrorMessage }}
                </span>
              </div>

            </div>
            <div class="row blankparent">
              <!-- <div class=" col-xs-10 no-padding blankerror">
              
            </div> -->
            </div>



            <div class="newReturn_location img_newReturn_location">{{"returnsUK.uploaddoclabel" | cxTranslate}}</div>
            <div class="Returnimagebox marginB25">
              <div class="leftside_Upload_Documentation">
                <div class="imageuploadsub">{{"returnsUK.uploadimgmsg" | cxTranslate}}</div>
                <button class="uploadbtn mappingpop-0" id="" type="button"
                  (click)="openFileUploadModal(additionalReturnData.returnsOrderData.locationId,additionalReturnData.returnsOrderData.qrCodeScannerUrl,additionalReturnData.returnsOrderData.qrToken,additionalReturnData.returnsOrderData.customerToken,additionalReturnData.returnsOrderData.companyName)">{{"returnsUK.uploadnviewimgtxt"
                  | cxTranslate}}</button>
                <span class="uploadedquat"><span class="uploadednum">{{
                    getUploadedImageCount(additionalReturnData.returnsOrderData.locationId) }}</span>
                  {{"returnsUK.imguploadtxt" | cxTranslate}}</span>
                <div class="imageformattext">{{"returnsUK.imgsizeerror" | cxTranslate}}</div>


                <div class="Returncheckbox">
                  <div *ngIf="getUploadedImageCount(additionalReturnData.returnsOrderData.locationId) > 0">
                    <!-- Content for when there are uploaded images -->
                    <label class="Retunrcheck-button"> <input type="checkbox" class="Return_check dynimagecheck"
                        [disabled]="true"> <span class="Retuncheck-button__control"></span> <label
                        class="Returnlabeltext">{{"returnsUK.imgnotuploadmsg" | cxTranslate}}</label>
                    </label>
                  </div>

                  <!-- Div to show if no images are uploaded -->
                  <div *ngIf="getUploadedImageCount(additionalReturnData.returnsOrderData.locationId) === 0">
                    <!-- Content for when there are no uploaded images -->
                    <label class="Retunrcheck-button"> <input type="checkbox" class="Return_check dynimagecheck"
                        [(ngModel)]="imgcheckboxChecked" (change)="imgonCheckboxChange()"
                        [disabled]="imgcheckboxDisabled"> <span class="Retuncheck-button__control"></span> <label
                        class="Returnlabeltext">{{"returnsUK.imgnotuploadmsg" | cxTranslate}}</label>
                    </label>
                    <label id="imagecheck0-error" class="error help-block" *ngIf="imgcheckboxErrorMessage">
                      <i class="fa-solid fa-circle-exclamation"></i>&nbsp;{{imgcheckboxErrorMessage}}
                    </label>
                  </div>



                  <div class="clearboth"></div>
                </div>

              </div>

              <!-- <div class="rightside">
                        <div class="newReturn_location">{{"returnsUK.exampeimgtxt" | cxTranslate}}</div>
                        <div class="Returnimageexample">
                          <div class="leftsideexm">
                            <img src="assets/images/ReturnImageExample3.png" class="img-fluid">
                          </div>
                          <div class="rightsideexm">
                            <img src="assets/images/ReturnImageExample2.jpg" class="img-fluid">
                          </div>
                        </div>
                      </div> -->
            </div>




          </div>
        </div>


      </div>


      <div class="btmsec" *ngIf="additionalReturnData">
        <div class="completetext">{{"returnsUK.completereturnreq" | cxTranslate}}</div>
        <div class="row">
          <div class="Returnsubmitbox col-md-7 leftside">
            <label class="Retunrcheck-button"> <input type="checkbox" class="Return_check" id="finalcheck"
                name="finalcheck" [(ngModel)]="checkboxChecked" (change)="onCheckboxChange()"> <span
                class="Retuncheck-button__control"></span> <label class="Returnlabeltext">{{"returnsUK.returnreqmsg" |
                cxTranslate}}</label>
            </label>
            <label id="finalcheck-error" class="error help-block" for="finalcheck" *ngIf="checkboxErrorMessage">
              <i class="fa-solid fa-circle-exclamation"></i>&nbsp;{{ checkboxErrorMessage }}
            </label>
            <div class="clearboth"></div>
          </div>

          <div class="submitbtnsection col-md-5 no-padding-right">
            <a class="prodReturn_exitBtn returnPopupshow" (click)="openExistpopup()">{{"returnsUK.exitlabel" |
              cxTranslate}}</a>
            <button class="productsumbitbtn" id="productSubmit" type="button"
              (click)="processAndSendPayloads()">{{"returnsUK.submitreturnreq" | cxTranslate}}</button>
          </div>
        </div>
      </div>
    </div>
    <section class="UkCreateReturn col-xs-12 col-md-12 no-padding" id="NoReturnThank" *ngIf="adlReturnThanks">

      <div class="Returnthank_box">
        <div class="thankReturn_head">{{"returnsUK.thankyoumsg" | cxTranslate}}</div>
        <div class="thankreturn_text">{{"returnsUK.emailconfirmsg" | cxTranslate}}</div>

        <a class="nopopshow returnPopupshow" (click)="goToreturn()">
          <div class="Returnbutton">View Returns</div>
        </a>
      </div>
      <!-- <app-custom-returns-thankyouvideo></app-custom-returns-thankyouvideo>
                <app-custom-returns-thankyoumaterials></app-custom-returns-thankyoumaterials>
                <app-custom-picture-resources></app-custom-picture-resources> -->
    </section>
    <div>




    </div>